// Idempotency-key generation. Keys are opaque, collision-resistant strings the
// gateway uses to deduplicate spins. The SAME key must be reused for any retry
// of the same logical spin; a NEW key denotes a NEW spin.
/** Generates a fresh idempotency key (UUID v4 where available). */
export function newIdempotencyKey() {
    const c = globalThis.crypto;
    if (c && typeof c.randomUUID === 'function') {
        return c.randomUUID();
    }
    // Fallback for environments without crypto.randomUUID.
    if (c && typeof c.getRandomValues === 'function') {
        const b = new Uint8Array(16);
        c.getRandomValues(b);
        b[6] = (b[6] & 0x0f) | 0x40;
        b[8] = (b[8] & 0x3f) | 0x80;
        const hex = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }
    throw new Error('no secure random source available for idempotency key');
}
/** Validates an idempotency key shape (matches the gateway's validation). */
export function isValidIdempotencyKey(key) {
    // Mirrors the gateway's validation: ^[A-Za-z0-9._:-]{8,128}$
    return /^[A-Za-z0-9._:-]{8,128}$/.test(key);
}
//# sourceMappingURL=ids.js.map